import data from './data.json';
import ReactDOM from 'react-dom';

export default () => {
  return data;
}